import type { Product } from '../../types/product';

/**
 * Maps a product from the database to the frontend model
 */
export function mapProductFromDB(dbProduct: any): Product {
  return {
    id: dbProduct.id,
    serialNumber: dbProduct.serial_number || 0,
    title: dbProduct.title || '',
    category: dbProduct.category || '',
    categoryYahoo: dbProduct.category_yahoo || '',
    startPrice: dbProduct.start_price || 0,
    buyItNowPrice: dbProduct.buy_it_now_price,
    quantity: dbProduct.quantity || 1,
    auctionDuration: dbProduct.auction_duration || 7,
    endTime: dbProduct.end_time || '22',
    description: dbProduct.description || '',
    descriptionTemplateId: dbProduct.description_template_id || null,
    condition: dbProduct.condition || '',
    itemNumber: dbProduct.item_number || '',
    itemNumber2: dbProduct.item_number2 || '',
    itemNumberPrefix: dbProduct.item_number_prefix || false,
    itemNumberSuffix: dbProduct.item_number_suffix || false,
    itemNumberSerial: dbProduct.item_number_serial || false,
    memo: dbProduct.memo || '',
    memoPrefix: dbProduct.memo_prefix || false,
    memoSuffix: dbProduct.memo_suffix || false,
    memoSerial: dbProduct.memo_serial || false,
    autoExtension: dbProduct.auto_extension || false,
    autoExtensionRate: dbProduct.auto_extension_rate || 5,
    autoExtensionCount: dbProduct.auto_extension_count || 1,
    autoExtensionByBid: dbProduct.auto_extension_by_bid || true,
    images: dbProduct.images || [],
    thumbnailImages: dbProduct.thumbnail_images || [],
    shippingUnspecified: dbProduct.shipping_unspecified || false,
    shippingLater: dbProduct.shipping_later || false,
    shippingCOD: dbProduct.shipping_cod || false,
    shippingResponsibility: dbProduct.shipping_responsibility || 'buyer',
    shippingTime: dbProduct.shipping_time || '2-3',
    shippingLocation: dbProduct.shipping_location || '',
    nekoposu: dbProduct.nekoposu || false,
    nekoCompact: dbProduct.neko_compact || false,
    nekoEazy: dbProduct.neko_eazy || false,
    nekoEazySize: dbProduct.neko_eazy_size || '',
    nekoEazyWeight: dbProduct.neko_eazy_weight || '',
    yuPacketMini: dbProduct.yu_packet_mini || false,
    yuPacket: dbProduct.yu_packet || false,
    yuPacketPlus: dbProduct.yu_packet_plus || false,
    yuPack: dbProduct.yu_pack || false,
    yuPackSize: dbProduct.yu_pack_size || '',
    yuPackWeight: dbProduct.yu_pack_weight || '',
    customShippingMethods: dbProduct.custom_shipping_methods || [],
    listingType: dbProduct.listing_type || 'auction',
    ratingRestriction: dbProduct.rating_restriction || true,
    badRatingRestriction: dbProduct.bad_rating_restriction || true,
    bidderAuthentication: dbProduct.bidder_authentication || false,
    returnsAccepted: dbProduct.returns_accepted || false,
    isFeatured: dbProduct.is_featured || false,
    featuredMinPrice: dbProduct.featured_min_price || 0,
    featuredMaxPrice: dbProduct.featured_max_price || 0,
    recommendedCollection: dbProduct.recommended_collection || false,
    recommendedCollectionRate: dbProduct.recommended_collection_rate || 0,
    isSelected: false,
    folderId: dbProduct.folder_id || null,
    allowHtmlInDescription: dbProduct.allow_html_in_description || false
  };
}

/**
 * Maps a product from the frontend model to the database
 */
export function mapProductToDB(product: Product): any {
  return {
    id: product.id,
    serial_number: product.serialNumber,
    title: product.title,
    category: product.category,
    category_yahoo: product.categoryYahoo,
    start_price: product.startPrice,
    buy_it_now_price: product.buyItNowPrice,
    quantity: product.quantity,
    auction_duration: product.auctionDuration,
    end_time: product.endTime,
    description: product.description,
    description_template_id: product.descriptionTemplateId,
    condition: product.condition,
    item_number: product.itemNumber,
    item_number2: product.itemNumber2,
    item_number_prefix: product.itemNumberPrefix,
    item_number_suffix: product.itemNumberSuffix,
    item_number_serial: product.itemNumberSerial,
    memo: product.memo,
    memo_prefix: product.memoPrefix,
    memo_suffix: product.memoSuffix,
    memo_serial: product.memoSerial,
    auto_extension: product.autoExtension,
    auto_extension_rate: product.autoExtensionRate,
    auto_extension_count: product.autoExtensionCount,
    auto_extension_by_bid: product.autoExtensionByBid,
    images: product.images,
    thumbnail_images: product.thumbnailImages,
    shipping_unspecified: product.shippingUnspecified,
    shipping_later: product.shippingLater,
    shipping_cod: product.shippingCOD,
    shipping_responsibility: product.shippingResponsibility,
    shipping_time: product.shippingTime,
    shipping_location: product.shippingLocation,
    nekoposu: product.nekoposu,
    neko_compact: product.nekoCompact,
    neko_eazy: product.nekoEazy,
    neko_eazy_size: product.nekoEazySize,
    neko_eazy_weight: product.nekoEazyWeight,
    yu_packet_mini: product.yuPacketMini,
    yu_packet: product.yuPacket,
    yu_packet_plus: product.yuPacketPlus,
    yu_pack: product.yuPack,
    yu_pack_size: product.yuPackSize,
    yu_pack_weight: product.yuPackWeight,
    custom_shipping_methods: product.customShippingMethods,
    listing_type: product.listingType,
    rating_restriction: product.ratingRestriction,
    bad_rating_restriction: product.badRatingRestriction,
    bidder_authentication: product.bidderAuthentication,
    returns_accepted: product.returnsAccepted,
    is_featured: product.isFeatured,
    featured_min_price: product.featuredMinPrice,
    featured_max_price: product.featuredMaxPrice,
    recommended_collection: product.recommendedCollection,
    recommended_collection_rate: product.recommendedCollectionRate,
    folder_id: product.folderId,
    updated_at: new Date().toISOString(),
    allow_html_in_description: product.allowHtmlInDescription
  };
}